import { render, staticRenderFns } from "./user_center_info.vue?vue&type=template&id=0db82d15&scoped=true"
import script from "./user_center_info.vue?vue&type=script&lang=js"
export * from "./user_center_info.vue?vue&type=script&lang=js"
import style0 from "./user_center_info.css?vue&type=style&index=0&id=0db82d15&prod&scoped=true&lang=css&external"
import style1 from "./user_center_info.vue?vue&type=style&index=1&id=0db82d15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db82d15",
  null
  
)

export default component.exports